import JSZip from "jszip";
import type { AutoGrade, ProjectAssetState } from "../types";

function safeName(value: string) {
  return value.trim().replace(/[^a-z0-9_-]+/gi, "_").replace(/^_+|_+$/g, "") || "project";
}

export async function downloadProject(options: {
  studentName: string;
  projectTitle: string;
  schoolYear: string;
  code: string;
  assets: ProjectAssetState;
  grade: AutoGrade;
}) {
  const zip = new JSZip();
  zip.file("main.py", options.code);
  zip.file(
    "project.json",
    JSON.stringify(
      {
        title: options.projectTitle,
        student: options.studentName,
        schoolYear: options.schoolYear,
        autoGrade: options.grade,
        exportedAt: new Date().toISOString(),
      },
      null,
      2,
    ),
  );

  for (const [kind, asset] of Object.entries(options.assets)) {
    if (!asset) continue;
    const response = await fetch(asset.previewUrl);
    if (!response.ok) continue;
    const extension = asset.name.split(".").pop()?.toLowerCase() || "png";
    zip.file(`assets/${kind}.${extension}`, await response.blob());
  }

  const blob = await zip.generateAsync({ type: "blob", compression: "DEFLATE" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${safeName(options.studentName)}_${safeName(options.projectTitle)}_${safeName(options.schoolYear)}.zip`;
  link.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 1_000);
}
